import _ from 'lodash'
import SLIDER_DATA_CONFIG from './config'
import Flickity from 'flickity'

class SliderDataClass {
    constructor( slider ) {
        this.DOM = {
            slider: slider
        }

        this.flckty = null

        this.init()
    }

    init() {
        this._flckty()
        console.log( this )
    }

    _flckty() {
        this.flckty = new Flickity( this.DOM.slider, {
            fade: true,
            prevNextButtons: false,
            pageDots: true,
            autoPlay: 5000
        })
    }
}

const SLIDERS_DATA = []
SLIDER_DATA_CONFIG.sliders.forEach( slider  => { SLIDERS_DATA.push( new SliderDataClass( slider ) ) })
export default SLIDERS_DATA